import React from 'react'

import styles from './style.module.scss'

const Image = ({
    data
}) => {
    return (
        <div className={styles.data_container}>
            <img className={styles.image} src={data.url} alt='o_O' />
        </div>
    )
}

export { Image }